import { ThunkAction } from "redux-thunk";
import { IComment } from "./commentsTypes";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../api/api";
import {
	saveLoaderCompleted,
	saveLoaderProgress,
	showMessage,
} from "../messages/messagesActions";

export const fetchCommentsAysnc =
	(
		typeId: string | number,
		onCallback: (isSuccess: boolean, data?: IComment[]) => void,
		company_outlet_uuid?: string,
		keyName: string = "module_uuid"
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
	async (dispatch, getState) => {
		try {
			let url = `/comment/get-comment?${keyName}=${typeId}`;
			if (company_outlet_uuid) {
				url += `&company_outlet_uuid=${company_outlet_uuid}`;
			}
			const res = await api.get(url);
			const data: IComment[] = res.data.data;

			onCallback(true, data);
		} catch (err: any) {
			onCallback(false);
			dispatch(
				showMessage({
					type: "error",
					message: err.response.data.message,
					displayAs: "snackbar",
				})
			);
		}
	};

export const upsertCommentAysnc =
	(
		comment: IComment,
		onCallback: (isSuccess: boolean) => void
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
	async (dispatch, getState) => {
		try {
			dispatch(saveLoaderProgress());
			const {
				create_ts,
				insert_ts,
				comment_t_id,
				comment_t_unique_id,
				created_by_uuid,
				modified_by_name,
				modified_by_uuid,
				module_unique_id,
				...payload
			} = comment;
			await api.post("/comment/upsert-comment", payload);

			let message = "Comment is saved successfully.";
			dispatch(
				showMessage({
					type: "success",
					message: message,
					displayAs: "snackbar",
				})
			);
			onCallback(true);
		} catch (err: any) {
			onCallback(false);
			dispatch(
				showMessage({
					type: "error",
					message: err.response.data.message,
					displayAs: "snackbar",
				})
			);
		} finally {
			dispatch(saveLoaderCompleted());
		}
	};
